import {Injectable} from '@angular/core';
import {ReportFilterFieldService} from '../../report-filter-field/report-filter-field.service';

@Injectable({
  providedIn: 'root'
})
export class ReportFilterReport001Service {

  constructor() {
  }

  static generate(filters: any, afilters: any[]): void {
    ReportFilterFieldService.hasCode(filters, afilters);
    ReportFilterFieldService.hasKind(filters, afilters);
    ReportFilterFieldService.hasAvailability(filters, afilters);
    ReportFilterFieldService.hasValidity(filters, afilters);
    ReportFilterFieldService.hasInventory(filters, afilters);
  }

}
